up.compiler('[interactive-tasklist]', function(prose){
  let checkboxes = Array.from(prose.querySelectorAll('input[type="checkbox"]'))
  checkboxes.forEach(function(checkbox){
    checkbox.addEventListener('click', async function(event){
      event.preventDefault()
      setDisabledStateForCheckboxes(true)

      await requestToUpdateCheckboxesInNoteProse(checkbox)

      setDisabledStateForCheckboxes(false)
    })
  })

  async function requestToUpdateCheckboxesInNoteProse(checkbox){
    try {
      let requestPath = prose.getAttribute('interactive-tasklist')
      let response = await up.request(requestPath, { method: 'PUT', params: generateParams(checkbox) })

      checkbox.checked = !checkbox.checked
      prose.setAttribute('last-text-edited-at', JSON.parse(response.text)['last_text_edited_at'])
    } catch (e){
      if (e instanceof up.Response && e.status === 409){
        let confirmed = confirm("This card has been changed by another user.\n Your changes were not saved.\n Press OK to reload.")
        if(confirmed){ window.location.reload() }
      } else {
        alert("Could not save your changes.")
      }
    }
  }

  function setDisabledStateForCheckboxes(disabled){
    checkboxes.forEach(function(checkbox) { checkbox.disabled = disabled })
  }

  function generateParams(clickedCheckbox){
    let params = {
      last_text_edited_at: prose.getAttribute('last-text-edited-at'),
    }
    params[`note[checkboxes][${checkboxes.indexOf(clickedCheckbox)}]`] = clickedCheckbox.checked ?  1 : 0

    return params
  }
})
